import store from '@/store'
export default [
  {
    path: '/reset-device-passwords',
    name: 'reset-device-password',
    meta: { requiresAuth: true },
    component: () => import('@/pages/reset-device-password/index.vue')
  }
]
